import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MentionableUser } from '@ps/survey-utils';

import { MentionableUsersApi } from '../../api/mentions/mentionable-users.api';

@Injectable({ providedIn: 'root' })
export class MentionableUsersService {
  private readonly _api = inject(MentionableUsersApi);

  public mentionableUsers(): Observable<MentionableUser[]> {
    return this._api.mentionableUsers();
  }
}
